export const environment = {
  REACT_APP_NAME: window._env_.REACT_APP_NAME,
  REACT_APP_BASE_URL: window._env_.REACT_APP_BASE_URL,
  REACT_APP_API_BASE_URL: window._env_.REACT_APP_API_BASE_URL,
}
